import { FileImageOutlined } from '@ant-design/icons';

interface Props {
  url?: string | null;
  /** 尺寸 class；預設為桌機表格用的 48×48（`h-12 w-12`）。 */
  sizeClassName?: string;
}

/** 文章封面縮圖；無圖時顯示帶色塊的優雅佔位。 */
export default function CoverThumb({ url, sizeClassName = 'h-12 w-12' }: Props) {
  if (url) {
    return (
      <img
        src={url}
        alt=""
        loading="lazy"
        className={`${sizeClassName} shrink-0 rounded-lg object-cover ring-1 ring-black/5`}
      />
    );
  }
  return (
    <div
      className={`${sizeClassName} flex shrink-0 items-center justify-center rounded-lg bg-[#fbf3e8] text-[#dd7900]/55 ring-1 ring-[#dd7900]/10`}
    >
      <FileImageOutlined style={{ fontSize: 18 }} />
    </div>
  );
}
